import React from 'react';
import ContactSales from './components/contactSales';
import SimplePricing, {
    SimplePricingProps,
} from './components/SimplePricing/SimplePricing';

export type RightSizePricingProps = SimplePricingProps & {
    renderInnerComponentOnly?: boolean;
};

export const RightSizePricingComponent: React.FC<RightSizePricingProps> = ({
    serviceFee,
    processingFee,
    renderInnerComponentOnly,
}) => {
    const innerComponent = (
        <>
            <SimplePricing
                serviceFee={serviceFee}
                processingFee={processingFee}
            />
            <ContactSales />
        </>
    );

    return (
        <>
            {renderInnerComponentOnly ? (
                innerComponent
            ) : (
                <section>
                    <div className="module-landing-page__module-container-content">
                        {innerComponent}
                    </div>
                </section>
            )}
        </>
    );
};
